import { Box, Button, Grid, Link, Typography } from "@mui/material";
import {
  CutomImageWraper,
  StyledFooterBox,
  StyledTitle,
  StyledViewWebsiteButton,
} from "./styles";
import orders from "assets/img/orders.png";
import { useAppSelector } from "hooks/useReduxHook";
import { errorSelector } from "features/error";
import { useMatchMobile } from "hooks/useMatchMobile";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { useNavigate } from "react-router-dom";

const NotFoundTimout = () => {
  const { isMatchMobile } = useMatchMobile();
  const navigate = useNavigate();
  const goToLink = () => {
    const url = process.env.REACT_APP_VIEW_DEMO_LINK; // Replace with the URL you want to open
    window.open(url, "_blank");
  };
  const handleStartOver = () => {
    localStorage.removeItem("formData");
    navigate("/");
  };

  return (
    <Grid container justifyContent="center" alignContent={"center"}>
      <Grid item xs={12} md={12} lg={12} sm={12}>
        <Box sx={{ mb: "30px" }}>
          <StyledTitle
            sx={{ fontSize: isMatchMobile ? "24px" : "36px", fontWeight: 700 }}
          >
            Oops!
            <br />
            Something Went Wrong
          </StyledTitle>
        </Box>
        <Box sx={{ mb: "30px" }}>
          <Typography>Want to view a demo menu?</Typography>
        </Box>
        <Box>
          <StyledViewWebsiteButton variant="contained" onClick={goToLink}>
            View Menu
          </StyledViewWebsiteButton>
        </Box>
        <StyledFooterBox sx={{ boxShadow: 4 }}>
          <Grid container m-0 p-0>
            <Grid item lg={6} md={12} xs={12} sm={12} m-0 p-0></Grid>
            <Grid item lg={6} md={12} xs={12} sm={12} m-0 p-0>
              <Button
                variant="contained"
                onClick={handleStartOver}
                startIcon={<RestartAltIcon />}
              >
                Start Over
              </Button>
            </Grid>
          </Grid>
        </StyledFooterBox>
      </Grid>
    </Grid>
  );
};

const NotFoundDefaultServer = () => {
  const { isMatchMobile } = useMatchMobile();
  const navigate = useNavigate();
  const goToLink = () => {
    const url = process.env.REACT_APP_VIEW_DEMO_LINK; // Replace with the URL you want to open
    window.open(url, "_blank");
  };

  const handleStartOver = () => {
    localStorage.removeItem("formData");
    navigate("/");
  };

  return (
    <Grid container justifyContent="center" alignContent={"center"}>
      <Grid item xs={12} md={12} lg={12} sm={12}>
        <Box sx={{ mb: "30px" }}>
          <StyledTitle
            sx={{ fontSize: isMatchMobile ? "28px" : "40px", fontWeight: 700 }}
          >
            We were unable to find your restaurant
          </StyledTitle>
        </Box>
        <Box sx={{ mb: "30px" }}>
          <Typography>Want to view a demo menu?</Typography>
        </Box>
        <Box>
          <StyledViewWebsiteButton variant="contained" onClick={goToLink}>
            View Menu
          </StyledViewWebsiteButton>
        </Box>
        <StyledFooterBox sx={{ boxShadow: 4 }}>
          <Grid container m-0 p-0>
            <Grid item lg={6} md={12} xs={12} sm={12} m-0 p-0></Grid>
            <Grid item lg={6} md={12} xs={12} sm={12} m-0 p-0>
              <Button
                variant="contained"
                onClick={handleStartOver}
                startIcon={<RestartAltIcon />}
              >
                Start Over
              </Button>
            </Grid>
          </Grid>
        </StyledFooterBox>
      </Grid>
    </Grid>
  );
};

const NotFound = () => {
  const errorData = useAppSelector(errorSelector.errorData);

  if (errorData.isTimeout || errorData.isServer) {
    return <NotFoundTimout />;
  }

  return <NotFoundDefaultServer />;
};

export default NotFound;
